import React from 'react';
import { Clock } from 'lucide-react';

const SubscriptionExpired = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '40px',
        maxWidth: '500px',
        textAlign: 'center'
      }}>
        <Clock 
          size={64} 
          color="#faad14" 
          style={{ margin: '0 auto 20px' }}
        />
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#262626'
        }}>
          Subscription Expired
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#595959',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          Your subscription has expired. Please renew your subscription to continue using this module.
        </p>
        
        <div style={{
          backgroundColor: '#fffbe6',
          border: '1px solid #ffe58f',
          padding: '16px',
          borderRadius: '4px',
          marginBottom: '24px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#d48806',
            margin: 0
          }}>
            Contact support for assistance:
          </p>
          <a 
            href="mailto:support@infoedmedia.com"
            style={{
              fontSize: '16px',
              color: '#d48806',
              fontWeight: '500',
              textDecoration: 'none'
            }}
          >
            support@infoedmedia.com
          </a>
        </div>
        
        <a 
          href="https://infoedmedia.com/shopping_cart/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            backgroundColor: '#faad14',
            color: 'white',
            borderRadius: '4px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '16px',
            marginRight: '12px'
          }}
        >
          Renew Subscription
        </a>
        
        <a 
          href="/api/logout/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            backgroundColor: '#f0f0f0',
            color: '#262626',
            borderRadius: '4px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '16px'
          }}
        >
          Logout
        </a>
      </div>
    </div>
  );
};

export default SubscriptionExpired;